import MarketPage from "./MarketPage";

export default MarketPage;
